import { SIGNED_ENTITY_BASE64_MAX_SIZE, SIGNED_ENTITY_BASE64_MIN_SIZE, } from '../constants';
import { base64Validator } from './base64';
export const signedEntityByRsaKeyValidator = base64Validator({
    requiredError: 'internal.signature.required',
    invalidFormatError: 'internal.signature.base64',
    minLength: {
        min: SIGNED_ENTITY_BASE64_MIN_SIZE,
        error: 'internal.signature.minLength',
    },
    maxLength: {
        max: SIGNED_ENTITY_BASE64_MAX_SIZE,
        error: 'internal.signature.maxLength',
    },
});
